<script setup>
const props = defineProps({
  // Icon-only trigger by default (used in the tight mobile hamburger row). Pass `expanded` in
  // roomier spots (e.g. the desktop top bar) for a wider fake-input-style trigger instead.
  expanded: {
    type: Boolean,
    default: false,
  },
})

const { defaultTransition } = useTailwindConfig()
const { resetAiSearch } = useAiSearch()
const { t, tm } = useI18n()

const isActive = ref(false)

const typedPlaceholder = props.expanded ? useTypewriter(tm('aiSearch.suggestions')) : ref('')

function openModal() {
  isActive.value = true
}
function closeModal() {
  isActive.value = false
  // useAiSearch's state is module-level (shared across mount/unmount), so it survives closing the
  // modal on its own — reset it explicitly here so the next open starts fresh.
  resetAiSearch()
}
</script>

<template>
  <div>
    <button
      v-if="expanded"
      type="button"
      class="w-80 flex flex-shrink-0 items-center gap-x-2 rounded-full bg-white/10 px-4 py-2 text-white hover:bg-white/20"
      :class="defaultTransition"
      @click="openModal"
    >
      <svg class="h-4 w-4 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z" /></svg>
      <span class="flex-1 truncate text-left text-sm text-white/70">{{ typedPlaceholder || t('aiSearch.placeholder') }}</span>
    </button>
    <div v-else class="flex items-center justify-center" @click="openModal">
      <svg class="h-6 w-6 cursor-pointer text-primary lg:text-white hover:opacity-50" :class="defaultTransition" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z" /></svg>
    </div>
    <UIModal :is-open="isActive" @action="closeModal" @on-close="closeModal">
      <LazyFormSearchEngine v-if="isActive" @action="closeModal" />
    </UIModal>
  </div>
</template>
